import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import BureauIcon from "../icon/bureau.png";
import AppnIcon from "../icon/appn.png";
import RuppeeIcon from "../icon/ruppee.png";
import OverallIcon from "../icon/overall.png";
import { Check, Close } from "@mui/icons-material";
import CheckIconImg from "../icon/greenright.png";
import CloseIconImg from "../icon/redcross.png";


// ------------------- Score Cards -------------------
const cardData = [
  {
    id: 1,
     value: "4.39",
    title: "Application Score",
    icon: AppnIcon,
    subtitle: "Private",
  },
  {
    id: 2,
  
     value: "4.00",
    title: "Financial Score",
    subtitle: "Private",
    icon: RuppeeIcon,
    
  },
  {
    id: 3,
   
      value: "730",
    title: "Bureau Score",
    subtitle: "AFBPT5811L",
    icon: BureauIcon,
  },
  {
    id: 4,
    value: "4.00",
    title: "Overall Score",
    subtitle: "Private",
    icon: OverallIcon,
  },
];

// ------------------- Eligibility Conditions -------------------
const eligibilityConditions = [
  { no: 1, text: "Dealer should have at least 6 months with Anchor", met: true },
  { no: 2, text: "Applicant shall be eligible if CMR > 5", met: true },
  {
    no: 3,
    text: "Eligible if CIBIL > 680 (proprietor/partners/51% shareholders)",
    met: true,
  },
  { no: 4, text: "Eligible if no settlement/write-off in last 1 yr", met: true },
  {
    no: 5,
    text: "Eligible if last year cash profit >0 & no accumulated loss",
    met: true,
  },
  {
    no: 6,
    text: "Shall be eligible if applicant Current Ratio is more than 1",
    met: false,
  },
  {
    no: 7,
    text: "Eligible if Credit Scorecard and individual score criteria met",
    met: false,
  },
];

// ------------------- Balance Sheet -------------------
const balanceSheet = {
  headers: ["Key Financials", "FY 24 (Provisional)", "FY23", "FY22"],
  rows: [
    ["Total Income", "₹1,04,32,799", "-", "-"],
    ["Total Expenditure", "₹99,56,862", "-", "-"],
    ["Total Current Liabilities", "₹14,20,493", "-", "-"],
    ["Total Debt (Long+Short)", "₹14,07,933", "-", "-"],
    ["Total Liabilities", "₹86,10,763", "-", "-"],
    ["Total Assets", "₹86,10,762", "-", "-"],
  ],
};

function StatsCards() {
  return (
    <Box sx={{ mx: "auto", width: "100%", mt: 2, }}>
      {/* ----------- Score Cards ----------- */}
      <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: {
            xs: "1fr", // mobile
            sm: "repeat(2, 1fr)", // tablet
            md: "repeat(4, 1fr)", // desktop
          },
          px: 2,
        }}
      >
        {cardData.map((c) => (
          <Card
            key={c.id}
            sx={{
              borderRadius: 3,
              boxShadow: 2,
              // display: "flex",             // make Card a flex container
              // justifyContent: "center",    // center horizontally
              // alignItems: "center",        //  center vertically
              // minHeight: 50               //  optional: gives enough height
              
            }}
          >
            <CardContent
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                alignItems: "center",      //  center horizontally
                textAlign: "center",       // text in center
              }}
            >
              {/* Icon */}
              <Box
                component="img"
                src={c.icon}
                alt={c.title}
                sx={{ width: 80, height: 80 }}
              />

              {/* Texts */}
              <Box>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 500, color: "#C7C7C7",alignItems:"center" }}
                >
                  {c.title}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: "#034A7F",alignItems:"center"  }}
                >
                  {c.value}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{ color: "#034A7F", fontSize: 12 ,alignItems:"center" }}
                >
                  {c.subtitle}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>

      {/* ----------- Eligibility + Balance Sheet ----------- */}
      {/* ----------- Eligibility + Balance Sheet ----------- */}
<Box
  sx={{
    display: "grid",
    gap: 2,
    gridTemplateColumns: {
      xs: "1fr", // stacked on mobile
      md: "1fr 1fr", // side by side on desktop
    },
    alignItems: "stretch", //  makes both cards same height
    px: 2,
    mt: 3,
  }}
>
  {/* Eligibility Conditions */}
<Card
  sx={{
    borderRadius: 3,
    boxShadow: 3,
    display: "flex",
    flexDirection: "column",
  }}
>
  <CardContent sx={{ flex: 1 }}>
    <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: "#034A7F" }}>
      Eligibility Conditions
    </Typography>

    {/*  Add scroll container */}
    <Box sx={{ width: "100%", overflowX: "auto" }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 500, color: "#C7C7C7", fontSize: "0.875rem", whiteSpace: "nowrap" }}>
              SL&nbsp;No
            </TableCell>
            <TableCell sx={{ fontWeight: 500, color: "#C7C7C7", fontSize: "0.875rem" }}>
              Conditions
            </TableCell>
            <TableCell align="center" sx={{ fontWeight: 500, color: "#C7C7C7", fontSize: "0.875rem" }}>
              Met/Not&nbsp;Met
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {eligibilityConditions.map((c) => (
            <TableRow key={c.no}>
              <TableCell sx={{ color: "#034A7F" }}>{c.no}</TableCell>
              <TableCell
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: 400,
                  fontSize: "12px",
                  color: "#034A7F",
                }}
              >
                {c.text}
              </TableCell>
              <TableCell align="center">
                <Box sx={{ width: 20, height: 20, display: "flex", alignItems: "center", justifyContent: "center", mx: "auto" }}>
                  {c.met ? (
                    <Box component="img" src={CheckIconImg} alt="check" sx={{ width: 20, height: 20 }} />
                  ) : (
                    <Box component="img" src={CloseIconImg} alt="close" sx={{ width: 20, height: 20 }} />
                  )}
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  </CardContent>
</Card>

{/* Balance Sheet */}
<Card sx={{ borderRadius: 3, boxShadow: 3, display: "flex", flexDirection: "column" }}>
  <CardContent sx={{ flex: 1 }}>
    <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: "#034A7F" }}>
      Balance Sheet Analysis
    </Typography>

    {/*  Add scroll container */}
    <Box sx={{ width: "100%", overflowX: "auto" , fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif' }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {balanceSheet.headers.map((h, i) => (
              <TableCell key={i} sx={{ fontWeight: 500, color: "#C7C7C7" , fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif' }}>
                {h}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {balanceSheet.rows.map((row, i) => (
            <TableRow
              key={i}
              sx={{
                "& td": {
                  fontSize: "12px",
                  fontFamily: "Inter, sans-serif",
                  py: 1.3,
                  whiteSpace: "nowrap", //  prevent wrapping
                },
              }}
            >
              {row.map((cell, j) => (
                <TableCell key={j} sx={{ color: "#034A7F" }}>{cell}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  </CardContent>
</Card>



</Box>

      
    </Box>
  );
}

export default StatsCards;
